import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/icons/mac/TopoMaps-Mac-128pt.png'
import _imports_1 from '@/assets/images/icons/mac/TopoMaps-Mac-128x2pt.png'


const _hoisted_1 = _imports_0 + ' 1x, ' + _imports_1 + ' 2x'
const _hoisted_2 = {
  id: "welcome",
  class: "intro-section"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "app-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    srcset: _hoisted_1,
    class: "img-fluid center"
  })
], -1)
const _hoisted_6 = { class: "intro_text_purchase" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 0 }

interface Props {
	title?: string;
	subtitle?: string;
	showSubtitle?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    title: { default: "Topo Maps+" },
    subtitle: { default: "Go Deeper Into The Backcountry" },
    showSubtitle: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { title: string, subtitle: string, showSubtitle: boolean }



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_2, [
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", { innerHTML: __props.title }, null, 8, _hoisted_7),
          (__props.showSubtitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.subtitle), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})